import { createContext, Dispatch, SetStateAction } from 'react';

type ScrollToImageProps = {
  newImageKey: string | null;
  setNewImageKey: Dispatch<SetStateAction<string | null>>;
};

export const ScrollToImageContext = createContext<ScrollToImageProps>({} as ScrollToImageProps);
